import { useQuery } from 'react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { getLicensePricingData } from 'services/licensePricingData/licensePricingDataService';
import { GlobalStoreInterface } from 'interface/globalStore';
import { LICENSE_QUERY_KEY } from '../../constants/purchaseLicenseModalConstants';

export const useGetLicensePricingData = (
  licenseDetailId: string,
  licenseQuantity: string,
) => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useQuery(
    [LICENSE_QUERY_KEY, licenseDetailId],
    () =>
      getLicensePricingData(
        sso,
        corpAccountNumber,
        licenseDetailId,
        licenseQuantity,
      ),
    {
      enabled: Boolean(
        sso && corpAccountNumber && licenseDetailId && licenseQuantity,
      ),
      retry: 1,
      refetchOnWindowFocus: false,
    },
  );
};
